import * as React from "react";
import {connect} from "react-redux";
import update from 'immutability-helper';
import {
    Alert, Button, Col, Form, FormControl, FormGroup, Glyphicon, Row, ToggleButton,
    ToggleButtonGroup
} from "react-bootstrap";
import * as ClientsAction from "../actions/ClientActions";
import * as ProjectsAction from "../actions/ProjectActions";
import * as EntryActions from "../actions/EntryActions";
import moment from 'moment';
import EntryTable from "../components/EntryTable";
import * as TaskActions from "../actions/TaskActions";
import Calendar from "rc-calendar";
import "rc-calendar/assets/index.css"
import * as UserActions from "../actions/UserActions";
import AutocompleteSearch from "../components/AutocompleteSearch";
import Loading from "../components/Loading";
import * as ReactDOM from "react-dom";
import * as MessageActions from "../actions/MessageActions";
import HoursFormControl from "../components/HoursFormControl";
import FirstTimeSetup from "../components/FirstTimeSetup";
import {needsSetup} from "../utils";

class AddEditEntryPage extends React.Component {

    defaultFormData = {
        id: undefined,
        project_id: undefined,
        client_id: undefined,
        date: moment().format("DD/MM/YYYY"),
        minutes: "",
        hours: "",
        description: "",
    };

    constructor() {
        super();

        this.state = {
            form: this.defaultFormData,
            editingEntry: null,
            hasDataTable: {},
            validationStates: {
                minutes: undefined,
                date: undefined,
            },
            message: undefined,
            waiting: false,
            autocompleteValue: '',
            autocompleteClosed: false,
            showAll: false,
            showTeam: false,
        }
    }

    componentWillMount() {
        this.loadData();
    }

    componentDidUpdate() {
        // this.loadData();
    }

    componentWillReceiveProps(props) {
        if (props.message && props.message.message) {
            setTimeout(() => this.props.closeMessage(), 3000);
        }
    }

    loadData() {
        this.props.fetchClientsIfNeeded();
        this.props.fetchProjectsIfNeeded();
        this.props.fetchUsersIfNeeded();
        this.loadEntries();
    }

    loadEntries(date) {
        if(!date) date = moment(this.state.form.date, "DD/MM/YYYY");
        this.props.fetchEntriesIfNeeded({
            from: parseInt(date.startOf("month").format("YYYYMMDD"), 10),
            to: parseInt(date.endOf("month").format("YYYYMMDD"), 10)
        }, date.format("YYYYMM"))
    }

    save(event) {
        event.preventDefault();

        if (!this.state.form.project_id) {
            this.setState({message: {type: "warning", "title": "Error", message: "Please select a project."}});
            return;
        }
        if (!this.state.form.task_id) {
            this.setState({message: {type: "warning", "title": "Error", message: "Please select a task."}});
            return;
        }
        if (!this.state.form.date) {
            this.setState({
                message: {
                    type: "warning",
                    "title": "Error",
                    message: "Please enter the date of the entry."
                }
            });
            return;
        }
        if (!this.state.form.minutes) {
            this.setState({message: {type: "warning", "title": "Error", message: "Please enter the amount of hours."}});
            return;
        }
        if (!this.state.form.description) {
            this.setState({message: {type: "warning", "title": "Error", message: "Please enter a description."}});
            return;
        }
        this.setState({waiting: true, message: undefined});

        let formData = Object.assign({}, this.state.form);

        // formData.minutes = HoursFormControl.parseMinutes(formData.minutes);
        // formData.minutes = formData.minutes;

        const date = formData.date.replace(/-/g, "/").split("/");
        const YYYY = parseInt(date[2], 10);
        const MM = (parseInt(date[1], 10) < 10 ? "0" : "") + parseInt(date[1], 10);
        const DD = (parseInt(date[0], 10) < 10 ? "0" : "") + parseInt(date[0], 10);
        formData.date = parseInt(YYYY + MM + DD, 10);
        formData.user_id = this.props.user.id;

        if (this.state.editingEntry) {
            formData.id = this.state.editingEntry;
        } else {
            document.getElementById("input-autocomplete").focus();
        }

        this.props.saveEntry(formData);

        this.setState({
            editingEntry: null,
            form: update(this.defaultFormData, { // values that should remain after saving
                date: {$set: this.state.form.date},
                project_id: {$set: this.state.form.project_id},
                task_id: {$set: this.state.form.task_id},
                client_id: {$set: this.state.form.client_id},
            }),
            autocompleteClosed: true
            // message: {
            //     type: "success",
            //     title: "Success!",
            //     message: "Entry successfully saved."
            // }
        });
    }

    edit(entry) {
        let dateStr = entry.date.toString();
        let date = dateStr.substr(6, 2) + "-" + dateStr.substr(4, 2) + "-" + dateStr.substr(0, 4);
        this.setState({
            editingEntry: entry.id,
            form: {
                date: date,
                project_id: entry.project.id,
                task_id: entry.task.id,
                client_id: entry.client.id,
                hours: HoursFormControl.parseMinutesToHours(entry.minutes) + "",
                minutes: entry.minutes,
                description: entry.description
            },
            message: undefined
        });
        const formNode = ReactDOM.findDOMNode(this.refs.form);
        window.document.getElementById("main-container").scrollTo(0, formNode.offsetTop);
    }

    remove() {
        if(window.confirm("Are you sure you want to remove this entry?")) {
            this.props.removeEntry(this.state.editingEntry);
            this.setState({
                editingEntry: null,
                form: update(this.defaultFormData, { // values that should remain after saving
                    date: {$set: this.state.form.date},
                    project_id: {$set: this.state.form.project_id},
                    task_id: {$set: this.state.form.task_id},
                    client_id: {$set: this.state.form.client_id},
                }),
                // message: {
                //     type: "success",
                //     title: "Success!",
                //     message: "Entry successfully removed."
                // }
            })
        }
    }

    cancel() {
        this.setState({
            editingEntry: null,
            form: update(this.defaultFormData, { // values that should remain after saving
                date: {$set: this.state.form.date},
                project_id: {$set: this.state.form.project_id},
                task_id: {$set: this.state.form.task_id},
                client_id: {$set: this.state.form.client_id},
            }),
            message: undefined
        })
    }

    handleChange(event) {

        if (event.target.name === "minutes") {
            this.setState({
                form: update(this.state.form, {
                    minutes: {$set: event.target.minutes},
                    hours: {$set: event.target.value}
                }),
                validationStates: update(this.state.validationStates, {
                    minutes: {$set: event.target.hasError ? 'error' : undefined}
                })
            });
            return;
        }

        if (event.target.name === "client_id") {
            this.setState({
                form:
                    update(this.state.form, {
                        "project_id": {$set: undefined},
                        "task_id": {$set: undefined},
                        "client_id": {$set: event.target.value}
                    })
            });
        } else {
            this.setState({
                form:
                    update(this.state.form, {
                        [event.target.name]: {$set: event.target.value}
                    })
            });
        }

        // this.setState(newState);
        // this.loadData();
    }

    handleDateChange(moment) {
        this.setState(update(this.state, {
            validationStates: {
                date: {$set: moment.isValid() ? undefined : 'error'},
            },
            form: {
                date: {$set: moment.format("DD/MM/YYYY")}
            }
        }));
        this.loadEntries(moment);
    }

    dateRender(current, value) {
        let userId = this.props.user.id;
        if (this.state.showTeam){
            userId = "all";
        }
        let minutesTable = this.props.minutesTable[userId] || {};
        const minutes = minutesTable[current.format("YYYYMMDD")];
        const hours = minutes && minutes / 60.0;

        let className = "";

        if (minutes) {
            className = "rc-calendar-date-has-content" + (hours < 8 ? (" value-" + Math.ceil(hours / 60)) : "");
        }

        return (
            <div className="rc-calendar-date rc-calendar-custom">
                <div className={className}>
                    {hours && hours > 0 && (<svg viewBox="0 0 32 32" className="rc-calendar-circle-svg">
                    <circle className="status" r="16" cx="16" cy="16" style={{strokeDasharray: (hours / 8 * 100) + " 100"}}/>
                </svg>)}
                    <span className="day">{current.format("DD")}</span>
                </div>
            </div>);
    }

    render() {

        const {clients, projects, users, tasks, entries, team, needsSetup} = this.props;

        if (!users.fetched) return <Loading loading={true} center />;
        if(needsSetup) return <FirstTimeSetup />;


        const momentDate = moment(this.state.form.date, "DD/MM/YYYY");
        const dbDate = parseInt(moment(this.state.form.date, "DD/MM/YYYY").format("YYYYMMDD"), 10);

        const clientArray = Object.values(clients.items);
        const projectArray = Object.values(projects.items).filter(project => {
            return project.client.id === this.state.form.client_id
        }).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        let allTasks = {};
        for (let task of tasks) {
            allTasks[task.id] = {
                id: task.id,
                name: task.name,
                client: {
                    id: task.client.id,
                    name: clients.items[task.client.id].name,
                },
                project: {
                    id: task.project.id,
                    name: projects.items[task.project.id].name,
                }
            }
        }
        const allTasksArray = Object.values(allTasks);
        const taskArray = tasks.filter(task => {
            return task.project.id === this.state.form.project_id
        });
        const entryArray = Object.values(entries.items).filter(entry => entry.date === dbDate);
        const readyToEdit = (this.props.match.params.project_id && this.state.form.id) || !this.props.match.params.project_id;
        const message = this.state.message || this.props.message;

        if (team && team.isSuspended) {
            return <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">Account Suspension</h1>
                </div>
                <div className="card-body">This team has been suspended. New entries are not allowed. Please consider
                    upgrading to the premium tier.
                </div>
            </div>
        }

        let currentStep = (this.state.form.task_id && this.state.form.task_id !== "Select a task") ? "active-step-2" : "active-step-1";

        if(!readyToEdit) return <div />;
        return (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        Report Hours
                        <Loading loading={this.props.entries.createFetching} right />
                    </h1>
                </div>
                <div className={"card-body hour-reporting " + currentStep}>
                    <Form onSubmit={this.save.bind(this)} id="hour-report-container" ref="form">
                        <Row>
                            <Col sm={5} smPush={7}>
                                {!momentDate.isValid() && (
                                    <Alert bsStyle="danger">
                                        <h4>Error</h4>
                                        Invalid date
                                    </Alert>
                                )}
                                {message && message.message && (
                                    <Alert bsStyle={message.type} onDismiss={() => {this.setState({message: null}); this.props.closeMessage()}}>
                                        <h4>{message.title}</h4>
                                        {message.message}
                                    </Alert>
                                )}
                                <Calendar
                                    showDateInput={false}
                                    value={momentDate.isValid() ? momentDate : moment()}
                                    dateRender={this.dateRender.bind(this)}
                                    onChange={this.handleDateChange.bind(this)}/>
                            </Col>
                            <Col sm={7} smPull={5}>
                                <FormGroup style={{marginBottom: "0"}}>
                                    <Row className="step-1">
                                        <div className="step-indicator" />
                                        <Col sm={12} className="autocomplete">
                                            <AutocompleteSearch
                                                items={allTasksArray}
                                                value={this.state.autocompleteValue}
                                                onChange={(e) => {
                                                    this.setState({autocompleteValue: e.target.value, autocompleteClosed: false})
                                                }}
                                                onSelect={(item) => {
                                                    let task = allTasks[item];
                                                    this.setState({
                                                        autocompleteValue: "",
                                                        form: update(this.state.form, {
                                                            client_id: {$set: task.client.id},
                                                            project_id: {$set: task.project.id},
                                                            task_id: {$set: task.id},
                                                        }),
                                                    });
                                                    document.getElementById("hour-report-container").className = "autocompleteUsed";
                                                    document.getElementById("taskDescription").focus();
                                                }}
                                                closedUntilChange={this.state.autocompleteClosed}
                                                onMenuVisibilityChange={(open) => {
                                                    if (open) document.getElementById("hour-report-container").className = "";}}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <Row>
                                    <Col sm={12}>
                                        <hr />
                                    </Col>
                                </Row>
                                <FormGroup>
                                    <Row className="step-1">
                                        <Col sm={4} xs={12}>
                                            <FormControl componentClass="select" name="client_id"
                                                         onChange={this.handleChange.bind(this)}
                                                         value={this.state.form.client_id}>
                                                <option>Select a client</option>
                                                {clientArray.map((client, i) => (
                                                    <option key={i} value={client.id}>{client.name}</option>
                                                ))}
                                            </FormControl>
                                        </Col>
                                        <Col sm={8} xs={12}>
                                            <FormControl componentClass="select" name="project_id"
                                                         onChange={this.handleChange.bind(this)}
                                                         value={this.state.form.project_id}>
                                                <option>Select a
                                                    project{projectArray.length === 0 ? " (select a client first)" : ""}</option>
                                                {projectArray.map((project, i) => (
                                                    <option key={i} value={project.id}>{project.name}</option>
                                                ))}
                                            </FormControl>
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup style={{marginBottom: "0"}}>
                                    <Row className="step-1">
                                        <Col sm={12}>
                                            <FormControl componentClass="select" name="task_id"
                                                         onChange={this.handleChange.bind(this)}
                                                         value={this.state.form.task_id}>
                                                <option value={null}>Select a
                                                    task{taskArray.length === 0 ? " (select a project first)" : ""}</option>
                                                {taskArray.map((task, i) => (
                                                    <option key={i}
                                                            value={task.id}>{task.name}</option>
                                                ))}
                                            </FormControl>
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <Row>
                                    <Col sm={12}>
                                        <hr />
                                    </Col>
                                </Row>
                                <Row className="step-2">
                                    <div className="step-indicator" />
                                    <Col sm={8} xs={12}>
                                        <FormGroup style={{marginBottom: "0"}}>
                                            <FormControl componentClass="textarea" name="description" id="taskDescription"
                                                 placeholder="Description"
                                                 className="description"
                                                 tabIndex="2"
                                                 value={this.state.form.description}
                                                 onChange={this.handleChange.bind(this)}/>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={4} xs={12}>
                                        <FormGroup style={{marginBottom: "0"}} validationState={this.state.validationStates.minutes}>
                                            <HoursFormControl name="minutes" id="minutes"
                                                              tabIndex="3"
                                                              className="hours"
                                                              value={this.state.form.hours}
                                                              onChange={this.handleChange.bind(this)}/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <FormGroup style={{marginTop: "20px"}}>
                                    <Row>
                                        <Col sm={12}>
                                            <Button bsStyle="primary" tabIndex="4" type="submit" disabled={this.props.entries.createFetching}>
                                                <Glyphicon glyph="ok"/>&nbsp;
                                                Save
                                            </Button>
                                            {this.state.editingEntry && (
                                                <div className="pull-right">
                                                    <Button style={{marginLeft: "5px"}} className="pull-right"
                                                            bsStyle="danger"
                                                            onClick={this.remove.bind(this)}>
                                                        <Glyphicon glyph="remove"/>&nbsp;
                                                        Remove
                                                    </Button>
                                                    <Button onClick={this.cancel.bind(this)}>
                                                        <Glyphicon glyph="remove"/>&nbsp;
                                                        Cancel
                                                    </Button>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </div>

                {entries.isFetching[dbDate] ? (
                    <div className="card-body">
                        Loading...
                    </div>
                ) : (
                    <div>

                        <div className="switch-view-team">
                            <span className="text">show full team</span>
                            <ToggleButtonGroup type="checkbox">
                                <ToggleButton onChange={event => this.setState({showTeam: event.target.checked})} value={0}><Glyphicon glyph={this.state.showTeam ? "eye-open" : "eye-close"}/></ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                        <EntryTable entries={entryArray}
                                clients={clients}
                                projects={projects}
                                users={users}
                                tasks={this.props.tasksList}
                                hide={["date"]}
                                history={this.props.history}
                                onItemClick={(entry) => {
                                    this.edit(entry)
                                }}
                                empty="There are no entries for this date yet."
                                activeUser={this.props.user}
                                editingEntry={this.state.editingEntry}
                                showTeam={this.state.showTeam} />
                    </div>
                )}
            </div>
        )
    }
}

export default connect(state => ({
    clients: state.clients,
    projects: state.projects,
    entries: state.entries,
    tasksList: state.tasks,
    tasks: state.tasks.items && Object.values(state.tasks.items).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())),
    team: state.teams.active,
    user: state.users.active,
    users: state.users,
    minutesTable: state.entries.minutes || {},
    message: state.message,
    needsSetup: needsSetup(state),
}), dispatch => ({
    fetchClientsIfNeeded: () => dispatch(ClientsAction.fetchClientsIfNeeded()),
    fetchProjectsIfNeeded: () => dispatch(ProjectsAction.fetchProjectsIfNeeded()),
    fetchEntriesIfNeeded: (date, key) => dispatch(EntryActions.fetchEntriesIfNeeded({date}, key)),
    fetchTasksIfNeeded: project => dispatch(TaskActions.fetchTasksIfNeeded(project, project)),
    fetchUsersIfNeeded: () => dispatch(UserActions.fetchUsersIfNeeded()),
    saveEntry: params => dispatch(EntryActions.saveEntry(params)),
    removeEntry: params => dispatch(EntryActions.removeEntry(params)),
    closeMessage: () => dispatch(MessageActions.closeMessage()),
}))(AddEditEntryPage);


// WEBPACK FOOTER //
// ./src/pages/AddEditEntryPage.js